<template>
  <div>
    <iframe v-for="(video, index) in videos" :key="index"   :src="'https://www.youtube.com/embed/' + video" width="100%" height="auto" frameborder="0" allow="autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
  </iframe>

  </div>
</template>

<script>
export default {
  props: {
    videos: Array
  }
}
</script>

<style lang="less">
.civii-video {
  width: 100%;
  height: auto;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/answers/Youtube/Youtube.vue